import { Box } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';

export default function MultiSelect(props) {
  return (
    <Box border={'1px solid #0000003B'} borderRadius={1} padding={2}>
      <InputLabel>{props.label}</InputLabel>
      {props.options.map(({ name }) => (
        <MenuItem key={name} value={name} onClick={() => props.onChange(name)}>
          <Checkbox checked={props.value.includes(name)} />
          <ListItemText primary={name} primaryTypographyProps={{ fontSize: 12 }} />
        </MenuItem>
      ))}
    </Box>
  );
}
